import styled from "styled-components";

import { theme } from "@/components/bild/theme";
import { IThemeProps } from "@/styles";
import { colors } from "@/styles/Variants";

import { Option } from "../styles";
const color = colors.bild;
const { margin, fontFamily, breakpoint } = theme;

export const OptionResult = styled(Option)`
  color: ${color.vader300};
  font-weight: 700;
`;

type ProgressBarProps = IThemeProps<{
  width: string;
  duration: number;
}>;
export const ProgressBar = styled.div<ProgressBarProps>`
  background: ${color.red500};
  width: ${(props: ProgressBarProps) => props.width};
  transition-duration: ${(props: ProgressBarProps) => props.duration}ms;
  transition-property: width;
  transition-timing-function: ease-out;
`;
export const Text = styled.div`
  text-align: left;
  padding: 4px ${margin.large * 2}px 4px 0;
  font-size: 18px;
  @media ${breakpoint.medium} {
    padding: 1px ${margin.medium * 2}px 1px 0;
    font-size: 16px;
  }
  @media ${breakpoint.small} {
    padding: 2px ${margin.large}px 2px 0;
    font-size: 16px;
  }
`;

export const Result = styled.div`
  display: flex;
`;

export const Percent = styled.div`
  margin-left: 8px;
  text-align: left;
  font-family: ${fontFamily.gotham};
  font-weight: 800;
  color: ${color.red500};
  font-size: 20px;
  line-height: 24px;
  width: 69px;
  @media ${breakpoint.medium} {
    font-size: 18px;
    line-height: 22px;
    width: 64px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
    line-height: 20px;
    width: 54px;
  }
`;
